// Generated by ReScript, PLEASE EDIT WITH CARE


function t(paginationColourOpt, activePaginationColourOpt, param) {
  var paginationColour = paginationColourOpt !== undefined ? paginationColourOpt : ({
        NAME: "hex",
        VAL: "C7C3C3"
      });
  var activePaginationColour = activePaginationColourOpt !== undefined ? activePaginationColourOpt : ({
        NAME: "hex",
        VAL: "ED1E09"
      });
  return {
          paginationColour: paginationColour,
          activePaginationColour: activePaginationColour
        };
}

export {
  t ,
}
/* No side effect */
